export default __webpack_public_path__ + "static/apple-touch-icon-6f3557842d46cd5f30a8f99caa5671c8.png";